import AssignmentIcon from "@mui/icons-material/Assignment";
import { CURRICULUMS, StudentServicePath } from "utils/constants";
import ListCurriculums from "./List";
import CreateCurriculum from "./Create";
import permissions from "app/permissions";
import EditCurriculum from "./Edit";
import ShowCurriculum from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <AssignmentIcon />,
  name: StudentServicePath + CURRICULUMS,
  title: "Учебни планове",
  list: <ListCurriculums />,
  show: <ShowCurriculum />,
  showPermission: permissions.canPreviewCurriculums,
  create: <CreateCurriculum />,
  createPermission: permissions.canCreateCurriculums,
  edit: <EditCurriculum />,
  editPermission: permissions.canUpdateCurriculums,
  permission: permissions.canPreviewCurriculums,
};
